import { AdvancedFilterInputSchema } from "@redotech/redo-fulfillment-common/fulfillment-group-summary-input";
import { BatchSuggestionSchema } from "@redotech/redo-fulfillment-operations-common/batch-suggestion";
import * as z from "zod";

export const getBatchSuggestions = {
  name: "getBatchSuggestions" as const,
  input: AdvancedFilterInputSchema,
  output: z.object({ suggestions: z.array(BatchSuggestionSchema) }),
};
